module.exports = "/_next/static/images/ProcessingValidationTransformation@2x-4f112ab6f06dc51641bfb6f39b261e3e.png";